import { useState } from 'react'
import useStyles from '../../styles'
import L from 'leaflet'
import { Polyline, Tooltip, useMapEvents } from 'react-leaflet'
import { Client, MountpointMap } from 'api'

interface Props {
  clients: Client[]
  mountpoints: MountpointMap[]
}

const ClientSourceLineLayer = ({ mountpoints, clients }: Props) => {
  const classes = useStyles()

  const [showDistance, setShowDistance] = useState(false)

  const lines: [L.LatLng, L.LatLng][] = []

  for (let client of clients) {
    for (let mountpoint of mountpoints) {
      if (client.sourceId === mountpoint.id) {
        lines.push([
          /**start point of the line */
          new L.LatLng(client.latitude, client.longitude),
          /**end point of the line */
          new L.LatLng(mountpoint.latitude, mountpoint.longitude),
        ])

        break
      }
    }
  }

  /**Displaying distance of the line in the specified zoom level range. */
  useMapEvents({
    zoom: ({ target }) => {
      if (target._zoom >= 10) setShowDistance(true)
      else setShowDistance(false)
    },
  })

  return (
    <>
      {lines.map((line, index) => {
        const distance = line[0].distanceTo(line[1])

        return (
          <Polyline positions={line} key={index}>
            {showDistance && (
              <Tooltip direction="right" permanent className={classes.sourceLineTooltip}>{`${(
                distance / 1000
              ).toFixed(3)}km`}</Tooltip>
            )}
          </Polyline>
        )
      })}
    </>
  )
}

export default ClientSourceLineLayer
